// Real positive reviews pulled from the Shopify App Store listings.
// Format used by the new homepage marquee.
export interface Review {
  text: string;
  store: string;
  country: string;
  rating: number;
}

export const buddifyReviews: Review[] = [
  {
    text: "Great app for brand partnerships. I love being able to sell partner products without holding extra inventory.",
    store: "PUREBRONZE_TANNING",
    country: "United Kingdom",
    rating: 5,
  },
  {
    text: "Very helpful platform for growing my product range and connecting with other stores. The setup was smooth and easy to use.",
    store: "AUM",
    country: "India",
    rating: 5,
  },
  {
    text: "Buddify made it so easy to find quality Shopify brands and add new products to my store. Simple, useful, and worth it.",
    store: "The Bed Store",
    country: "United Kingdom",
    rating: 5,
  },
  {
    text: "Great opportunity to add to your catalog.",
    store: "H&L SALON",
    country: "Australia",
    rating: 5,
  },
  {
    text: "Buddify has been great for me. I am a solo owner, and it is nice to know I have some help on my side. Buddify is helping to grow my business, and I am very grateful for their help.",
    store: "submerch.com",
    country: "United States",
    rating: 5,
  },
  {
    text: "We've been impressed with how easy the platform is to use and integrate into our workflow. It has helped us connect with other businesses and keep inventory synchronised across partners.",
    store: "Tap and Share",
    country: "Australia",
    rating: 5,
  },
  {
    text: "This app is actually working and has generated real transactions for our business. I like that it's commission-based, so you only pay when it delivers results.",
    store: "Amu Nutrition",
    country: "United States",
    rating: 5,
  },
  {
    text: "The app started working while it was being customized. Catalog expansion is next to implement. The support is excellent and very prompt. There is so much to Buddify to use to increase store visibility and sales.",
    store: "PowerLung Inc",
    country: "United States",
    rating: 5,
  },
  {
    text: "Great app if you want to increase sales!",
    store: "LRT Metal Decor & More",
    country: "United States",
    rating: 5,
  },
  {
    text: "Buddify makes it easy to partner and host products with other businesses making it easy to collaborate with others! We found it easy to share product listings, inventory counts, pricing, and shipping policies with others.",
    store: "Colorado Threads Clothing",
    country: "United States",
    rating: 5,
  },
  {
    text: "Great app and always improving.",
    store: "DV Multimedia LLC",
    country: "United States",
    rating: 5,
  },
  {
    text: "I have been using Buddify for over a year now and I am very happy with them. They offer products from all over the world which are very unique. I recommend them to anyone.",
    store: "jewelrycafee.com",
    country: "United States",
    rating: 5,
  },
  {
    text: "The amount of sales I have got is incredible and the support team is fantastic. Have had some questions when I first installed and they got back to me straight away!",
    store: "Henry and Flo",
    country: "Australia",
    rating: 5,
  },
  {
    text: "Buddify has made growing my business a no brainer. Their systems are so easy to use, the syncing, cataloging, checkout processes are all so streamlined. Highly recommend!",
    store: "Lash Fox Pro",
    country: "Canada",
    rating: 5,
  },
  {
    text: "Highly recommend this app. Works great with Shopify and is easy to integrate into your store.",
    store: "Natural Euphoria",
    country: "United Kingdom",
    rating: 5,
  },
  {
    text: "Great App For Building New Supplier And Retail Partnerships. We have had a very positive experience with Buddify so far. It opens up much wider opportunities around supplier relationships and product sourcing.",
    store: "The CBD Hut",
    country: "United Kingdom",
    rating: 5,
  },
  {
    text: "So far I am very happy that I installed the app. Integration is seamless and all my products are almost listed. Customer service by David was very helpful.",
    store: "Badass Blankets",
    country: "Germany",
    rating: 5,
  },
  {
    text: "Fantastic platform, thanks so much for reaching out!",
    store: "TEN GRAND",
    country: "United Kingdom",
    rating: 5,
  },
  {
    text: "David really helped me set up my account and my products. Very efficient and went above and beyond.",
    store: "LADYBUGLASHES",
    country: "United Kingdom",
    rating: 5,
  },
];

export const buddyAIReviews: Review[] = [
  {
    text: "We love how naturally Buddy AI recommends products and guides shoppers through the buying journey. The support team has also been fantastic whenever we've needed help.",
    store: "The Bed Store",
    country: "United Kingdom",
    rating: 5,
  },
  {
    text: "Buddy AI was incredibly easy to set up and started answering customer questions right away. It's like having an extra team member available 24/7.",
    store: "PUREBRONZE_TANNING",
    country: "United Kingdom",
    rating: 5,
  },
  {
    text: "Buddy AI helped answer customer questions instantly and made shopping feel much more personal. The setup was incredibly easy.",
    store: "BesLife4U",
    country: "United States",
    rating: 5,
  },
  {
    text: "The best app. Easy to set up in minutes. David is very helpful with any questions. Happy to be using this app.",
    store: "FabYouForever Boutique",
    country: "Ireland",
    rating: 5,
  },
  {
    text: "A great addition to our outdoor store, I'm sure it drives conversions with customers who are on the fence. The team are helpful and approachable when needed. Recommended.",
    store: "The Escapades",
    country: "United Kingdom",
    rating: 5,
  },
  {
    text: "Recently signed up for the free trial and so far delighted - 100% Success Rate!",
    store: "Vinyl Nirvana Ltd",
    country: "United Kingdom",
    rating: 5,
  },
  {
    text: "Buddify has helped me reach customers I normally wouldn't reach. My business is growing because of Buddify. I am extremely happy with the choice I made to partner with Buddify.",
    store: "submerch.com",
    country: "United States",
    rating: 5,
  },
  {
    text: "This app has been a very positive experience and definitely helps with getting online sales.",
    store: "Garden Effects",
    country: "Canada",
    rating: 5,
  },
  {
    text: "Great app to enhance your Shopify website! If you want great sales, it's a must.",
    store: "LRT Metal Decor & More",
    country: "United States",
    rating: 5,
  },
  {
    text: "Implementation is straightforward and results yielded quickly. No training or set up necessary - the agent gives better info than the integrated Shopify chat did - the discount tool works well.",
    store: "BANZ® Carewear USA",
    country: "United States",
    rating: 5,
  },
  {
    text: "I highly recommended. I am super busy and having this additional tool helps both customer and business. I would not sleep on this.",
    store: "Bee Well Bakery LLC",
    country: "United States",
    rating: 5,
  },
  {
    text: "Buddy AI has been incredible! Taking all our info from our site and using it to answer questions and produce sales. Impressive!",
    store: "IT'S THE BALM CO.",
    country: "United States",
    rating: 5,
  },
  {
    text: "David was fantastic walked through the set up and feature and everything is very easy and responsive and the AI looks to be something can add value to our business.",
    store: "Just Perfume",
    country: "Australia",
    rating: 5,
  },
  {
    text: "I am very happy about how Buddify has worked to increase the sales at my shop. I recommend them with no hesitation.",
    store: "Warren Robinson Books",
    country: "United States",
    rating: 5,
  },
  {
    text: "A Clever Way To Improve Conversion And Customer Support. What I like most is that it is not just a simple chatbot. It helps customers with product discovery, answering questions, and encouraging higher-value purchases.",
    store: "The CBD Hut",
    country: "United Kingdom",
    rating: 5,
  },
  {
    text: "Great App, support is 10/10 would highly recommend.",
    store: "The Crafty Black Dog",
    country: "United Kingdom",
    rating: 5,
  },
  {
    text: "The app is amazing. You can set different percentages for each product, collection or the same discount on all products easily. The client has the opportunity to negotiate the product price using AI. It's just perfect.",
    store: "Ornare Living",
    country: "Spain",
    rating: 5,
  },
  {
    text: "A+",
    store: "Topical Skin",
    country: "United States",
    rating: 5,
  },
  {
    text: "A very user-friendly and helpful app. The setup was quick, the interface is clean and easy to navigate. It really improved the customer experience and we’ve noticed better engagement. Definitely recommend!",
    store: "Mikos Store",
    country: "Türkiye",
    rating: 5,
  },
  {
    text: "Wow, I mean David is a superstar. Awesome support and the app really working for us.",
    store: "danozdirect",
    country: "Australia",
    rating: 5,
  },
  {
    text: "Great Shopify app! The product recommendations and instant support make the shopping experience much smoother, and we've already noticed more completed purchases.",
    store: "Clinix",
    country: "Pakistan",
    rating: 5,
  },
  {
    text: "This AI has genuinely reduced our support workload while helping us convert more visitors into customers. Easy setup and surprisingly smart responses.",
    store: "Creek Store DxB",
    country: "United Arab Emirates",
    rating: 5,
  },
  {
    text: "This has increased my sales noticeably! It works as advertised. The best part is that Buddy AI has the best app support of anyone in the business, by far!",
    store: "Nanotech Environmental",
    country: "Canada",
    rating: 5,
  },
  {
    text: "Installed it in minutes and it started answering customer questions right away. Love how it recommends products naturally instead of feeling like a basic chatbot.",
    store: "Hanna honey",
    country: "United Arab Emirates",
    rating: 5,
  },
];

